import { services } from '../../../../constants/services';
import { remove, DeleteResponse } from '../../../../utils/api';

export class DeleteUserService {
  async run(id: string | number): Promise<DeleteResponse> {
    return remove(`${services.users}`, id);
  }
}
